module.exports = __webpack_public_path__ + "img/5.d25c3afc.jpg";